module.exports = __webpack_public_path__ + "img/xl_llk.c4c28c4b.png";